var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('fa-icon',{staticClass:"loader__spinner",attrs:{"icon":"spinner","spin":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }